// Impulse carrega seções dinamicamente; ligamos no load e quando a seção é re-renderizada
(function initTestimonialsSwiperScope() {
  const SELECTOR_SECTION  = '[class^="section-template"][class$="__ws_review_image_mcWfVq"]';
  const SELECTOR_SLIDER   = '[class^="testimonials-slider-template"][class$="__ws_review_image_mcWfVq"]';
  const SELECTOR_PREV     = '[class^="testimonials-btn-prev-template"]';
  const SELECTOR_NEXT     = '[class^="testimonials-btn-next-template"]';
  const SELECTOR_PAG      = '[class^="testimonials-pagination-template"]';

  function mount(root) {
    const section = (root && root.matches?.(SELECTOR_SECTION)) ? root : (root || document).querySelector(SELECTOR_SECTION);
    if (!section) return;
    const sliderEl = section.querySelector(SELECTOR_SLIDER);
    if (!sliderEl) return;

    // evita instanciar 2x
    if (sliderEl.__swiper) return;

    const prevEl = section.querySelector(SELECTOR_PREV);
    const nextEl = section.querySelector(SELECTOR_NEXT);
    const pagEl  = section.querySelector(SELECTOR_PAG);

    const swiper = new Swiper(sliderEl, {
      loop: true,
      spaceBetween: 28,
      slidesPerView: 1.2,
      speed: 5000,                 // “médio”: baixa = mais rápido, alta = mais lento
      autoplay: {
        delay: 1,                  // 1ms => efeito contínuo
        disableOnInteraction: false,
        pauseOnMouseEnter: true,   // pausa ao passar o rato
      },
      navigation: prevEl && nextEl ? { prevEl, nextEl } : undefined,
      pagination: pagEl ? { el: pagEl, clickable: true } : undefined,
      allowTouchMove: true,
      breakpoints: {
        640:  { slidesPerView: 2 },
        1024: { slidesPerView: 4 }
      }
    });

    // pausa enquanto o dedo/click fica pressionado
    const pressStart = () => { try { swiper.autoplay.stop(); } catch (e) {} };
    const pressEnd   = () => { try { swiper.autoplay.start(); } catch (e) {} };

    sliderEl.addEventListener('pointerdown', pressStart, { passive: true });
    sliderEl.addEventListener('pointerup',   pressEnd,   { passive: true });
    sliderEl.addEventListener('pointerleave',pressEnd,   { passive: true });
    sliderEl.addEventListener('touchcancel', pressEnd,   { passive: true });

    sliderEl.__swiper = swiper; // marca como montado
  }

  // monta no load inicial
  document.addEventListener('DOMContentLoaded', () => mount());

  // monta novamente quando a secção é recarregada no editor/customizer do Shopify
  document.addEventListener('shopify:section:load',  e => mount(e.target));
  document.addEventListener('shopify:section:select', e => mount(e.target));
})();
